import { FC, ReactElement } from 'react'

import { ConnectedPincode } from '../../connectors'
import { LoginLayout } from '../../containers'

import './PincodePage.scss'

interface PincodePageProps {
    className?: string;
}

const PincodePage: FC<PincodePageProps> = (): ReactElement => (
    <div className="pincode-page">
        <LoginLayout>
            <ConnectedPincode />
        </LoginLayout>
    </div>
)

export default PincodePage
